export function buildResourceSearchRequest({
  search,
  category,
  manage,
  state,
  cursor,
  limit = 24,
}) {
  return {
    search,
    ...(category ? { category } : {}),
    ...(manage ? { state } : {}),
    ...(cursor ? { cursor } : {}),
    limit,
  };
}

export const resourceStateLabel = (state) =>
  ({ draft: 'Drafts', published: 'Published', archived: 'Archived' })[state];

export const resourceFileKind = (mimeType) => (mimeType === 'application/pdf' ? 'PDF' : 'IMG');
